import { PropertiesSelectors } from '../../../../selectors';
import { useSelector } from '../../../../selectors/useSelector';

import SpecialOfferItem from './SpecialOfferItem';

type Props = {
  isInPostingPath?: boolean;
  onEditOfferClick?: (action: string) => void;
};

export const SpecialOfferContainer = ({ onEditOfferClick = () => {}, isInPostingPath = false }: Props) => {
  const { isFeed, listingAlias, specialOffers } = useSelector((state) =>
    PropertiesSelectors.makeCurrentProperty(state),
  );

  return specialOffers.length > 0 ? (
    <SpecialOfferItem
      onEditOfferClick={onEditOfferClick}
      isInPostingPath={isInPostingPath}
      isFeed={isFeed}
      listingAlias={listingAlias}
      specialOffer={specialOffers[0]}
    />
  ) : null;
};

export default SpecialOfferContainer;
